import { render } from "./FilterSvg.vue?vue&type=template&id=a3b3d476"
import script from "./FilterSvg.vue?vue&type=script&lang=js"
export * from "./FilterSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__